import CascadeReelGroup from "../../../vendor_core/core/src/views/CascadeReelGroup";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SymbolSpineAnimation from "../../../vendor_core/core/src/views/SymbolSpineAnimation";
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import ICoinGeneration from '../../model/ICoinGeneration';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import { Tween } from '../../../vendor_core/core/src/Tween';
import CoinModel from '../../model/CoinModel';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import GameSoundVars from '../enums/GameSoundVars';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import Utils from '../../../vendor_core/core/src/utils/Utils';
import { DisplayObject } from 'pixi.js';
import ReelSymbol from '../../../vendor_core/core/src/views/Symbol';
import SymbolAnimation from '../../../vendor_core/core/src/views/SymbolAnimation';
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { ISpinificationData } from "../../../vendor_core/core/src/server/data/ISpinData";

export default class TRWCascadeReelGroup extends CascadeReelGroup {
    public areBonusSymbolsInAnim: boolean = false;

    create(
        scene: SceneView,
        symbolData ?: any[][],
        groupConfig ?: {
            winLineLayer?: string;
            celеbrationLayer?: string;
            winSymbolsLayer?: string;
            reelExtraSymbols?: number;
        }) {
        super.create(scene, symbolData, groupConfig);

        this.spinners.forEach(spinner => {
            spinner.setCustomHit((symId: number, reelId: number, rowId: number) => {
                const isLastCascade = SpinModel.cascadeIndex == SpinModel.cascades.length - 1;
                if (isLastCascade && SpinModel.hasFreespinsWon()) {
                    // const isLastSymbol = reelId == this.reels.length - 1 && rowId == this.reels[this.reels.length - 1].symbols.length - 1;
                    // if (isLastSymbol) {
                    //     SoundController.playSound(GameSoundVars.FREESPINS_TRIGGERED);
                    // }
                } else {
                    if (SpinModel.cascadeIndex == 0) {
                        if (GameModel.gameConfig.spinifySymIds.indexOf(symId) != -1) {
                            // SoundController.playSound(GameSoundVars.SCATTER_APPEAR);
                        } else if (rowId == this.reels[this.reels.length - 1].symbols.length - 1) {
                            const isNormalStop = !SpinModel.stopImmediately && !GameModel.turboSpin;
                            if (isNormalStop) {
                                // SoundController.playSound(`${SoundVars.EFFECT_REEL_STOP}_${reelId}`, false, null, true);
                            } else {
                                if (reelId == this.reels.length - 1) {
                                    SoundController.playSound(SoundVars.EFFECT_REEL_QUICK_STOP, false, null, false);
                                }
                            }
                        }
                    }
                }
            })
        })
    }
    public spin(): void {
        super.spin();

        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .containers.get("reels")
            .enableMask();

        let delay: number = 70;
        this.spinners.forEach(() => {
            Tween.delayedCall(delay / 1000, () => {
                SoundController.playSound("reel_start", false, null, true);
            });
            delay += 100;
        });
    }

    public onReelStopped(reelIdx: number) {
        this.reelsSpinning--;
        this.dispatcher.emit(GameEvents.REEL_STOPPED, reelIdx);
        if (this.reelsSpinning == 0) {
            this.dispatcher.emit(GameEvents.ALL_REELS_STOPPED);
            this.onAllReelsStopped();
        }
    }

    public cascadeFillRemaining(delay = 0, spinificationData?: ISpinificationData): void {
        super.cascadeFillRemaining();
        this.checkBonusSymbolsAnim();
    }

    protected onAllReelsStopped(): void {
        if (AutoplayModel.autoSpinLimitReached) {
            UIController.toggleComponent("autoplayLimitPopup");
        }
    }

    protected setUpPopSymPromise(reel: number, cell: number, animName?: string): Promise<SymbolSpineAnimation> {
        return PromiseHelpers.getFakePromise()
    }
    protected areTrailsEnabled(): boolean {
        return false;
    }
    protected getFillExplodeProps(reelIdx: number): { explodesMap: any[]; explodedItems: boolean[]; lockedOverlay: number[]; } {
        const result = super.getFillExplodeProps(reelIdx);
        const cascadeData: ICoinGeneration = SpinModel.generations[SpinModel.cascadeIndex];
        // Need to remove appearing coin from exploded pool !!!
        cascadeData.newCoins?.forEach(c => {
            if (c.coordinate.x === reelIdx) {
                if (result.explodedItems[c.coordinate.y]) {
                    result.explodedItems[c.coordinate.y] = false;
                    result.explodesMap[reelIdx][c.coordinate.y] = false;
                }

            }
        })

        return result
    }

    ////////////////////// GAME SPECIFIC //////////////////////

    // This need to stay coin symbol skull anim when start spin //
    public stopSymbolAnimations() {
        this.off(GameEvents.GROUP_ANIM_COMPLETE);
        this.winSymbolsView.stopAll();
    }
    // This need to stay coin symbol skull anim when start spin //
    protected stopReels(delay?: number): void {
        super.stopReels(delay);
        Tween.delayedCall((delay || 0), () => {
            CoinModel.showCurrentCoins()
        });
        this.sortSymbols();

        this.checkBonusSymbolsAnim();
    }

    private checkBonusSymbolsAnim(): void {
        const symbols: number[][] = SpinModel.getCurrentFinalSymbols().get(SpinModel.reelSetIndex);
        let bonusSymbolsCount: number = 0;
        let bonusSymbolsCoords: { x: number, y: number }[] = [];

        const numberToFS: number = SpinModel.isInFreespins() ? 3 : 4;

        symbols.forEach((reel, idxReel) => {
            reel.forEach((symId, idxRow) => {
                if (symId == 11) {
                    bonusSymbolsCount++;
                    bonusSymbolsCoords.push({ x: idxReel, y: idxRow });
                }
            });
        });

        if (!this.areBonusSymbolsInAnim && bonusSymbolsCount == numberToFS) {
            bonusSymbolsCoords.forEach((el, idx) => {
                let symbol = this.getSymbolAt(el.x, el.y);
                symbol.playAnimation("win");
            });
            
            SoundController.playSound("win_medium");
            this.areBonusSymbolsInAnim = true;
        }
    }

    ////////////////////// GAME SPECIFIC //////////////////////
}
